<template>
    <v-container
            fluid
            fill-height
    >
        <v-layout
                align-center
                justify-center
        >
            <v-flex
                    xs12
                    sm8
                    md8
            >
                <v-row no-gutters >

                    <v-col cols="12" xl="7" md="7" sm="12" class="text-center pa-5 white--text">

                        <v-img class="cover-img text-center" src="../../assets/firme/bg-logo.png"></v-img>
                        <h1>Поштовани волонтери,</h1>
                        <h2>Молимо вас да попуните своје податке у контакт форми. Очекујте ускоро позив од стране Општинских кризних центара.<br>
                            Хвала вам на подршци и разумевању.</h2>
                        <!-- <v-img  src="../../assets/company.svg"></v-img>-->
                    </v-col>
                    <v-col cols="12" xl="5" md="5" sm="12" class="d-flex align-center"  >
                        <v-card class="pa-5 w-full" >
                            <v-form
                                @submit.prevent="register()"
                                ref="form"
                                v-model="valid"
                                lazy-validation
                            >
                                <v-text-field
                                        label="Имејл адреса"
                                        :rules="[requiredRule]"
                                        required
                                ></v-text-field>
                                <v-text-field
                                        label="Лично име"
                                        :rules="[requiredRule]"
                                        required
                                ></v-text-field>
                                <v-text-field
                                        label="Број телефона"
                                        :rules="[requiredRule]"
                                        required
                                        type="number"
                                ></v-text-field>

                                <v-textarea
                                        label="Остави поруку"
                                        :rules="[requiredRule]"
                                        required
                                ></v-textarea>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn type="submit" color="primary" :disabled="!valid">Пошаљи</v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-col>
                </v-row>
            </v-flex>
        </v-layout>
    </v-container>
</template>


<script>
  export default {
    name: "Volunteers",

    data: () => ({
      requiredRule: v => !!v || 'Ово поље је неопходно',
      valid: true,
    }),
    methods:{
      register(){

        this.$refs.form.validate()
        if(this.valid) {
          this.displaySuccessText = true;
          this.$swal({ title: "Контакт форма није готова!", type: "error" })
          this.$refs.form.reset()
          this.$refs.form.resetValidation()
        }
      },
    }
  };
</script>
<style scoped>

    .cover-img{
        margin: 0 auto;
    }

    h1{
        padding: 25px 0;
        font-size: 56px;
        font-weight: 700;
        line-height: 1;
    }
    .container.fill-height{
        background: #0d4077!important;
    }
    .contact-section{
        color: white;
    }
    .contact-section .row.text-center.no-gutters{
        padding: 47px 0;
    }
    @media only screen and (max-width: 768px) {
        h1{
            font-size: 25px;
        }
        h2{
            font-size: 18px!important;
            font-weight: 400;
        }
    }
</style>
